import type { HTMLProps } from 'react';
import styled from 'styled-components';

import { animation } from '@/styles/style';

type FadeDivProps = HTMLProps<HTMLDivElement> & {
  status?: boolean;
  duration?: number; // ms
};

const FadeDiv = styled.div<FadeDivProps>`
  animation-name: ${({ status = true }) =>
    status ? animation.fadeIn : animation.fadeOut};
  animation-duration: ${({ duration }) =>
    duration ? `${duration}ms` : '200ms'};
`;

export default FadeDiv;
